import './coverage-map.scss'

const selectors = {
  cm: '[data-cm]',
  cmSearch: '[data-cm-search]',
  cmSelect: '[data-cm-select]',
  cmFilter: '[data-cm-filter]',
  cmItem: '[data-cm-item]',
  cmClear: '[data-cm-clear]',

  active: 'active',
}

const defaultFilters = {
  Name: '',
  Region: '',
  Tech: [],
}

class Filters {
  defaultFilters
  activeFilters
  clearButtonElement

  constructor(defaultFilters, clearButtonElement) {
    this.defaultFilters = defaultFilters
    this.activeFilters = defaultFilters
    this.clearButtonElement = clearButtonElement
  }

  set(values) {
    this.activeFilters = { ...this.activeFilters, ...values }

    if (JSON.stringify(this.activeFilters) === JSON.stringify(this.defaultFilters)) {
      this.clearButtonElement.classList.remove(selectors.active)
    } else {
      this.clearButtonElement.classList.add(selectors.active)
    }

    return this.activeFilters
  }

  get() {
    return this.activeFilters
  }

  clear() {
    this.activeFilters = this.defaultFilters
    this.clearButtonElement.classList.remove(selectors.active)

    return this.defaultFilters
  }
}

const filterItems = (items, filters) =>
  items.forEach((item) => {
    const isVisible = Object.entries(filters).every(([filter, filterValue]) => {
      if (filter === 'Tech') {
        if (!filterValue.length) return true

        const itemTechList = item.dataset[`cmItem${filter}`].toLowerCase().split(',')

        return filterValue.some((v) => itemTechList.indexOf(v) !== -1)
      }

      return item.dataset[`cmItem${filter}`].toLowerCase().includes(filterValue.toLowerCase())
    })

    item.setAttribute('data-cm-item', isVisible)
  })

const initCoverageMap = (container) => {
  const search = container.querySelector(selectors.cmSearch)
  const select = container.querySelector(selectors.cmSelect)
  const filters = container.querySelectorAll(selectors.cmFilter)
  const items = container.querySelectorAll(selectors.cmItem)
  const clear = container.querySelector(selectors.cmClear)

  const activeFilters = new Filters(defaultFilters, clear)

  const handleClear = () => {
    filterItems(items, activeFilters.clear())

    filters.forEach((filter) => {
      filter.classList.remove(selectors.active)
    })

    search.value = ''
    select.value = ''
  }

  search.addEventListener('input', ({ target: { value } }) => {
    filterItems(items, activeFilters.set({ Name: value }))
  })

  select.addEventListener('change', ({ target: { value } }) => {
    filterItems(items, activeFilters.set({ Region: value }))
  })

  filters.forEach((filter) => {
    filter.addEventListener('click', () => {
      const { Tech } = activeFilters.get()

      const isActive = Tech.includes(filter.dataset.cmFilter)
      const techList = isActive ? Tech.filter((t) => t !== filter.dataset.cmFilter) : [...Tech, filter.dataset.cmFilter]

      filterItems(items, activeFilters.set({ Tech: techList }))

      filter.classList[isActive ? 'remove' : 'add'](selectors.active)
    })
  })

  clear.addEventListener('click', () => {
    handleClear()
  })
}

document.addEventListener('DOMContentLoaded', async function () {
  const containers = document.querySelectorAll(selectors.cm)

  containers?.forEach(initCoverageMap)
})
